<template>
    <p @click="test"  class="pt-5">1</p>
</template>
<script>
import Vue from "vue";
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    count: 0
  },
  mutations: {
    increment (state) {
      state.count++
    }
  }
})
export default {
      name: "Test",
      store: store,
      methods: {
          test(){
            console.log(1)
          }
      },
}
</script>